import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, onChange, readOnly = true, size = "h-5 w-5", testid }) => {
  const [hover, setHover] = useState(0);
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className="flex items-center gap-0.5" data-testid={testid}>
      {stars.map((s) => {
        const active = (hover || value) >= s;
        return (
          <button
            type="button"
            key={s}
            disabled={readOnly}
            onClick={() => !readOnly && onChange && onChange(s)}
            onMouseEnter={() => !readOnly && setHover(s)}
            onMouseLeave={() => !readOnly && setHover(0)}
            className={readOnly ? "cursor-default" : "cursor-pointer transition-transform hover:scale-110"}
            aria-label={`${s} star`}
            data-testid={testid ? `${testid}-star-${s}` : undefined}
          >
            <Star className={`${size} ${active ? "fill-amber-400 text-amber-400" : "fill-none text-slate-300"}`} />
          </button>
        );
      })}
    </div>
  );
};

export const RatingSummary = ({ avg = 0, count = 0, size = "h-4 w-4", testid }) => {
  const { t } = useTranslation();
  if (!count) {
    return (
      <span className="text-xs text-muted-foreground" data-testid={testid}>
        {t("reviews.noRatings")}
      </span>
    );
  }
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      <StarRating value={Math.round(avg)} readOnly size={size} />
      <span className="text-xs font-semibold text-foreground">{avg.toFixed(1)}</span>
      <span className="text-xs text-muted-foreground">({count})</span>
    </div>
  );
};
